import { render, staticRenderFns } from "./RefsSnapshot.vue?vue&type=template&id=36aa8d7f"
import script from "./RefsSnapshot.vue?vue&type=script&lang=ts"
export * from "./RefsSnapshot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports